jQuery( document ).ready(function($) {

    var STOP_STATE = 'STOP_STATE', PRE_STATE = 'PRE_STATE', PLAY_STATE = 'PLAY_STATE', END_STATE = 'END_STATE'; // Game states
    var MOBILE = 'MOBILE', TABLET = 'TABLET', DESKTOP = 'DESKTOP';                                              // Game sizes
    var ASSETS_SRC = '/wp-content/themes/5aldia/dist/images/potato/';
    var RETURN_TIME = .5;

    var game_data = (function(){
        var _this = this;
        _this.game_states = [STOP_STATE, PRE_STATE, PLAY_STATE, END_STATE];
        _this.current_game_state = STOP_STATE;
        _this.current_game_size = '';
        _this.current_main_food = '';
        _this.wrapper = '';
        _this.breakpoints = [
            {'width':1170,  'size':DESKTOP },
            {'width':600,   'size':TABLET },
            {'width':0,     'size':MOBILE }
        ];
        _this.game_height = [
            {'height':0,    'size':DESKTOP },
            {'height':820,  'size':TABLET },
            {'height':550,  'size':MOBILE }
        ];
        _this.props = [
            {'pic':'prop_1'},
            {'pic':'prop_2'},
            {'pic':'prop_3'},
            {'pic':'prop_4'},
            {'pic':'prop_5'},
            {'pic':'prop_6'},
            {'pic':'prop_7'},
            {'pic':'prop_8'},
            {'pic':'prop_9'},
            {'pic':'prop_10'},
            {'pic':'prop_11'},
            {'pic':'prop_12'},
            {'pic':'prop_13'},
            {'pic':'prop_14'},
            {'pic':'prop_15'},
            {'pic':'prop_16'},
            {'pic':'prop_17'},
            {'pic':'prop_18'},
            {'pic':'prop_19'},
            {'pic':'prop_20'},
            {'pic':'prop_21'}
        ];
        _this.food = [
            {'pic':'pera',
                'big':[
                    {'size': DESKTOP,   'style':'left: 361px; top: 134px; width: 330px;' },
                    {'size': TABLET,    'style':'left: 140px; top: 124px; width: 330px;' },
                    {'size': MOBILE,    'style':'left: 60px; top: 34px; width: 250px;' }
                ],
                'slider':[
                    {'size': DESKTOP,   'style':'' },
                    {'size': TABLET,    'style':'' },
                    {'size': MOBILE,    'style':'' }
                ]
            },
            {'pic':'maduixa',
                'big':[
                    {'size': DESKTOP,   'style':'left: 350px; top: 114px; width: 360px;' },
                    {'size': TABLET,    'style':'left: 127px; top: 104px; width: 360px;' },
                    {'size': MOBILE,    'style':'left: 63px; top: 36px; width: 251px;' }
                ],
                'slider':[
                    {'size': DESKTOP,   'style':'' },
                    {'size': TABLET,    'style':'' },
                    {'size': MOBILE,    'style':'' }
                ]
            },
            {'pic':'pastanaga',
                'big':[
                    {'size': DESKTOP,   'style':'left: 410px; top: 14px; width: 230px;' },
                    {'size': TABLET,    'style':'left: 204px; top: 14px; width: 230px;' },
                    {'size': MOBILE,    'style':'left: 84px; top: -206px; width: 230px;' }
                ],
                'slider':[
                    {'size': DESKTOP,   'style':'padding: 5px 30px 22px 30px' },
                    {'size': TABLET,    'style':'padding: 5px 30px 22px 30px' },
                    {'size': MOBILE,    'style':'padding: 1px 16px 8px 18px' }
                ]
            },
            {'pic':'pebrot',
                'big':[
                    {'size': DESKTOP,   'style':'left: 350px; top: 124px; width: 340px;' },
                    {'size': TABLET,    'style':'left: 150px; top: 114px; width: 340px;' },
                    {'size': MOBILE,    'style':'left: 70px; top: 44px; width: 230px;' }
                ],
                'slider':[
                    {'size': DESKTOP,   'style':'' },
                    {'size': TABLET,    'style':'' },
                    {'size': MOBILE,    'style':'padding: 4px 10px 8px 9px;' }
                ]
            },
            {'pic':'brocoli',
                'big':[
                    {'size': DESKTOP,   'style':'left: 287px; top: 124px; width: 450px;' },
                    {'size': TABLET,    'style':'left: 90px; top: 94px; width: 450px;' },
                    {'size': MOBILE,    'style':'left: 26px; top: 34px; width: 330px;' }
                ],
                'slider':[
                    {'size': DESKTOP,   'style':'padding: 6px 2px 1px 7px' },
                    {'size': TABLET,    'style':'padding: 6px 2px 1px 7px' },
                    {'size': MOBILE,    'style':'padding: 6px 5px 8px 5px;' }
                ]
            },
            {'pic':'esberginia',
                'big':[
                    {'size': DESKTOP,   'style':'left: 280px; top: 80px; width: 460px;' },
                    {'size': TABLET,    'style':'left: 84px; top: 90px; width: 440px;' },
                    {'size': MOBILE,    'style':'left: 40px; top: 40px; width: 310px;' }
                ],
                'slider':[
                    {'size': DESKTOP,   'style':'padding: 8px 10px 4px 10px' },
                    {'size': TABLET,    'style':'padding: 8px 10px 4px 10px' },
                    {'size': MOBILE,    'style':'padding: 6px 5px 8px 5px;' }
                ]
            }
        ];

        function findFoodByName( food, name )
        {
            var food_item = _.find(food, function (o){
                return o.pic === name;
            });
            return _.cloneDeep( food_item );
        }

        return {
            setState: function( state ) { _this.current_game_state = state },
            getBreakpoints: function(){ return _.cloneDeep( _this.breakpoints ) },
            getSize: function(){ return _this.current_game_size },
            setSize: function( size ){ _this.current_game_size = size },
            getMainFood: function(){ return _this.current_main_food },
            setMainFood: function( food_name ){ _this.current_main_food = food_name },
            getFood: function(){ return _.cloneDeep( _this.food ) },
            getProps: function(){ return _.cloneDeep( _this.props ) },
            setWrapper: function( wrapper ){ _this.wrapper = wrapper },
            getWrapper: function(){ return _this.wrapper },
            updateGameStatus: function( callback_function )
            {
                if( callback_function )
                    callback_function();
            },
            getFoodItemByName: function( name )
            {
                return findFoodByName( _this.food, name );
            },
            getFoodItemSliderStyleByName: function( name, size )
            {
                var food_item = findFoodByName( _this.food, name );
                var slider = _.find(food_item.slider, function(o){
                    return o.size === size;
                });

                return slider.style;
            },
            getFoodItemBigStyleByName: function( name, size )
            {
                var food_item = findFoodByName( _this.food, name );
                var big = _.find(food_item.big, function(o){
                    return o.size === size;
                });

                return big.style;
            }
        }
    })();

    $(window).resize(function(){
        check_window_width();
        clearPropsOnCurrentFood();
        setMainFoodSize();
    });

    function check_window_width()
    {
        var game_size = getBreakpointSizeFromWindowSize( $(window).width(), game_data.getBreakpoints() );
        if( game_data.getSize() === '' || game_data.getSize() !== game_size) {
            initGame("#game_potato_wrapper", game_size);
        }else {
            game_data.setSize(game_size);
        }
    }

    function getBreakpointSizeFromWindowSize( window_size, breakpoints)
    {
        var size = _.find(breakpoints, function(o){
            return o.width < window_size;
        });
        return size.size;
    }

    function initGame( selector, game_size )
    {
        game_data.setState( PRE_STATE );
        game_data.setWrapper( selector );
        game_data.setSize( game_size );

        var size = game_data.getSize();
        var wrapper = game_data.getWrapper();

        $(selector).removeClass()
                   .addClass( game_size );

        drawButtons(wrapper, size);
        drawFoodSlider(wrapper, game_data.getFood(), size);
        makeFoodSliderDraggable('.game_potato_food_slider');
        //drawMockup(wrapper, size);
        var start_food_item = game_data.getFoodItemByName( 'maduixa' );
        drawMainFood(wrapper, start_food_item.pic, size );
        selectMainFood(start_food_item.pic);
        drawModalPropsWindow(wrapper, size);
        closePropsModalWindow();
        drawProps(wrapper, game_data.getProps(), size);
        makePropSliderDraggable('.game_potato_props_slider');
        updateStatus();
    }

    function drawMockup( wrapper, size )
    {
        $(".game_potato_mockup").detach();

        var img = '<img src="' + ASSETS_SRC + 'mockup_desktop.png" class="game_potato_mockup ' + size + '">';
        $(wrapper).append( img );
    }

    function drawButtons( wrapper, size )
    {
        $(".game_potato_btn_delete,.game_potato_btn_add,.game_potato_btn_photo").detach();

        var btn_add = '<img src="' + ASSETS_SRC + 'btn_add.png" class="game_potato_btn_add ' + size + '">';
        var btn_delete = '<img src="' + ASSETS_SRC + 'btn_delete.png" class="game_potato_btn_delete ' + size + '">';
        var btn_photo = '<img src="' + ASSETS_SRC + 'btn_photo.png" class="game_potato_btn_photo ' + size + '">';
        $(wrapper).append( btn_add );
        $(wrapper).append( btn_delete );
        $(wrapper).append( btn_photo );

        $(".game_potato_btn_add").click(function(){
           openPropsModalWindow();
        });

        $(".game_potato_btn_delete").click(function(){
            clearPropsOnCurrentFood();
        });

        $(".game_potato_btn_photo").click(function(){
            takePhotoAndShare();
        });
    }

    function openPropsModalWindow()
    {
        $(".game_potato_props_modal_window").removeClass('closed');
    }

    function closePropsModalWindow()
    {
        $(".game_potato_props_modal_window").addClass('closed');
    }

    function clearPropsOnCurrentFood()
    {
        $(".game_potato_draggable_prop").detach();
        updateStatus();
    }

    function takePhotoAndShare()
    {
        var elementP = document.getElementById('game_potato_wrapper');
        $('.game_potato_btn_add,.game_potato_btn_photo,.game_potato_btn_delete,.game_potato_food_slider,.delete').css('opacity',0);

        html2canvas(elementP).then(function(canvas) {
            var text = '';
            if (language_site == 'es_ES') {
                text = '¡Comparte tu personaje!';
            } else if (language_site == 'ca') {
                text = 'Comparteix el teu personatge!';
            } else {
                text = 'Share your character!';
            }


            var cont_canvas = '<div class="photo_taken"><div class="delete"></div><div class="share"><p>' + text + '</p><i class="fa fa-facebook-square share-fb" aria-hidden="true"></i><i class="fa fa-twitter-square share-tw" aria-hidden="true"></i></div></div>';
            $(wrapper).append(cont_canvas);
            //$('.photo_taken').append(canvas);
            var myImage = new Image();
            myImage.src = canvas.toDataURL("image/png", 1.0);
            myImage.alt = 'personatge';
            $('.photo_taken').append(myImage);
            $('.photo_taken .delete').click(function(event) {
                $('.photo_taken').detach();
            });
            $('.photo_taken .share-fb').click(function(event) {
                  var uploadedImgURL = uploadTakenPhoto(myImage.src, shareFB);
            });

            $('.photo_taken .share-tw').click(function(event) {
                  var uploadedImgURL = uploadTakenPhoto(myImage.src, shareTW);
            });

            $('.game_potato_btn_add,.game_potato_btn_photo,.game_potato_btn_delete,.game_potato_food_slider,.delete').css('opacity',1);
        });
    }

    function uploadTakenPhoto(img_data, callback) {
        jQuery.ajax({
            url : uploadimage.ajax_url,
            type : 'POST',
            data : {
                action : 'upload_image',
                img_data : img_data
            },
            success : function( response ) {
                callback(response);
                return response;
            }
        });
    }

    function shareFB(data){
        if (data != 0 ) {
            var fbpopup = window.open("https://www.facebook.com/sharer/sharer.php?u="+data, "pop", "width=600, height=400, scrollbars=no");
            return false;
          }
    }

    function shareTW(data){
        if (data != 0 ) {
            var fbpopup = window.open("http://twitter.com/share?url="+data+"&hashtags=5aldia", "pop", "width=600, height=400, scrollbars=no");
            return false;
          }
    }

    function drawFoodSlider(wrapper, food, size)
    {
        $(".game_potato_food_slider").detach();

        if(game_data.getSize() == 'MOBILE'){
            var slider_width = _.size(food) * 82;
        }else{var slider_width = _.size(food) * 140;}

        console.log('slider_width '+slider_width+' _.size(food) '+_.size(food));
        var slider_width_food = '<ul class="game_potato_food_slider ' + size + '" style="width: ' + slider_width + 'px">';
        _.forEach(food, function(value){
            var style = game_data.getFoodItemSliderStyleByName(value.pic, size);
            var img =   '<li class="game_potato_food_item_wrapper ' + size + '" style="' +
                style + '" ' +
                'data-name="'+ value.pic + '" '+
                '>'+
                '<img src="' + ASSETS_SRC + value.pic +'.png" ' +
                'class="game_potato_food_item ' +
                size + '" ' +
                '></li>';
            slider_width_food = slider_width_food + img;
        });
        slider_width_food = slider_width_food + '</ul>';

        $(wrapper).append( slider_width_food );

        $(".game_potato_food_item_wrapper").click(function(){
            if(game_data.getMainFood() !== $(this).data('name')) {
                drawMainFood(wrapper, $(this).data('name'), size);
                selectMainFood($(this).data('name'));
            }
        });
    }

    function makeFoodSliderDraggable(selector)
    {
        //Draggable.create(selector, {type:"x", edgeResistance:0.65, lockAxis:true, throwProps:true});//TODO: Pendiente tener el plugin de throwprops.

        Draggable.create(selector, {
            type:"x",
            edgeResistance:0.65,
            lockAxis:true,
            throwProps:true,
            onDragEnd:function(){
                var pos = $(this.target).position().left;
                if(pos > 20){
                    TweenLite.to($(this.target), RETURN_TIME, {x:20, ease: Back.easeOut});
                }
                var limit = ($(this.target).width() + 20 - $(window).width()) * -1;
                if(pos < limit){
                    TweenLite.to($(this.target), RETURN_TIME, {x:limit, ease: Back.easeOut});
                }
            }
        });
    }

    function drawMainFood(wrapper, food_name, size)
    {
        $(".game_potato_main_food_wrapper,.game_potato_main_food").detach();

        var div = '<div class="game_potato_main_food_wrapper ' + size + '">';

        var style = game_data.getFoodItemBigStyleByName(food_name, size);
        div = div + '<img src="' + ASSETS_SRC + food_name + '.png" class="hvr-wobble-vertical animated game_potato_main_food ' + size + '" style="' + style + '">';
        div = div + '</div>';
        $(wrapper).append(div);

        game_data.setMainFood( food_name );
    }

    function selectMainFood(food_name)
    {
        $('.game_potato_food_slider .selected').removeClass("selected");
        $('.game_potato_food_slider [data-name="'+food_name+'"]').addClass("selected");
    }

    function drawModalPropsWindow(wrapper, size)
    {
        $(".game_potato_props_modal_window").detach();

        var div = '<div class="game_potato_props_modal_window ' + size + '">';
        $(wrapper).append( div );

        $(".game_potato_props_modal_window").click(function(){
            closePropsModalWindow();
        })
    }

    function drawProps(wrapper, props, size)
    {
        $(".game_potato_props_slider").detach();

        var slider_width = _.size(props) / 2 * 170;
        var slider_width_props = '<div class="game_potato_props_slider ' + size + '" style="width: ' + slider_width + 'px">';
        _.forEach(props, function(value){
            var img =   '<img src="' + ASSETS_SRC + value.pic +'.png" ' +
                        'class="game_potato_prop_item ' +
                        size + '" ' +
                        'data-name="'+ value.pic +'">';
            slider_width_props = slider_width_props + img;
        });
        slider_width_props = slider_width_props + '</div>';

        $(".game_potato_props_modal_window").append( slider_width_props );

        $(".game_potato_prop_item").click(function(){
            closePropsModalWindow();
            createPropAndStartDragging(wrapper, $(this).data("name"), size);
        });
    }

    function makePropSliderDraggable(selector)
    {
        //Draggable.create(selector, {type:"x", edgeResistance:0.65, lockAxis:true, throwProps:true});//TODO: Pendiente tener el plugin de throwprops.
        Draggable.create(selector, {
            type:"x",
            edgeResistance:0.65,
            lockAxis:true,
            throwProps:true,
            onDragEnd:function(){
                var pos = $(this.target).position().left;
                if(pos > 20){
                    TweenLite.to($(this.target), RETURN_TIME, {x:20, ease: Back.easeOut});
                }
                var limit = ($(this.target).width() + 20 - $(window).width()) * -1;
                if(pos < limit){
                    TweenLite.to($(this.target), RETURN_TIME, {x:limit, ease: Back.easeOut});
                }
            }
        });
    }

    function createPropAndStartDragging(wrapper, prop_name, size)
    {
        var $mfw = $(".game_potato_main_food_wrapper");
        var $mf = $(".game_potato_main_food");
        var prop = '<div id="prop_'+prop_name+'" class="game_potato_draggable_prop ' + size + '"><div class="delete" id="prop_'+prop_name+'_delete"></div><img src="' + ASSETS_SRC + prop_name + '.png"></div>';
        $(wrapper).append(prop);

        var $prop = $('#' + 'prop_'+prop_name);
        var center_position_left = $("#game_potato_wrapper").width() / 2 - $prop[0].getBoundingClientRect().width / 2;
        var center_position_top = $mfw.position().top + $mf.position().top + $mf.height() / 2 - $prop[0].getBoundingClientRect().height / 2;

        $prop.css({
           'left': center_position_left,
           'top': center_position_top
        });

        Draggable.create('.game_potato_draggable_prop', {
            type:"x,y",
            edgeResistance:0.65,
            onDragStart:function(){
                $(this.target).addClass("dragging");
            },
            onDragEnd:function(){
                $(this.target).removeClass("dragging");
            }
        });

        $('#prop_'+prop_name+'_delete').click(function(){
            $(this).parent(".game_potato_draggable_prop").detach();
            updateStatus();
        });

        updateStatus();
    }

    function updateStatus()
    {
        if($(".game_potato_draggable_prop").length > 0){
            $(".game_potato_btn_delete").removeClass("hidden");
        }else{
            $(".game_potato_btn_delete").addClass("hidden");
        }
    }

    function setMainFoodSize()
    {
        var style = game_data.getFoodItemBigStyleByName(game_data.getMainFood(), game_data.getSize());
        $(".game_potato_main_food").attr("style",style);
    }

    check_window_width();

});
